import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

//components
import {
  Curve,
  NewBackButton,
  NoticeIcon,
  TrophyIcon,
} from "../../../../components/svgs";
import { CurveHolder, StyledText } from "../../../../components/common/basic";

// theme
import { useTheme } from "../../../../hooks";

import { Desktop } from "../../../../containers/common";


const formatISODate = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours() % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = date.getHours() < 12 ? "am" : "pm";
  const formattedDate = `${day}.${month}.${year} | ${hours}:${minutes}${ampm}`;
  return formattedDate;
};

const AllActivitiesScreen = () => {

  const { themeContext, theme } = useTheme();
  let history = useHistory();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const gameData = [
    {
      gameStatus: "won",
      gameInfo: "You played Trivia Tuesday and won KFC Voucher",
      date: "17.12.2023",
      time: "3:36pm",
    },
    {
      gameStatus: "redeemed",
      gameInfo: "You played Trivia Tuesday and won KFC Voucher",
      date: "17.12.2023",
      time: "3:36pm",
    },
    {
      gameStatus: "pickUp",
      gameInfo: "You played Trivia Tuesday and won KFC Voucher",
      date: "17.12.2023",
      time: "3:36pm",
    },
  ];

  return (
    <>
      <Desktop>
        <MainHolder>
          <Children>
            <div
              style={{
                width: "90%",
                display: "flex",
                alignItems: "center",
                width: "55%",
                justifyContent: "space-between",
              }}
            >
              <BackButtonContainer
                onClick={() => {
                  history.goBack();
                }}
                style={{ zIndex: 100, marginLeft: 20 }}
              >
                <NewBackButton />
              </BackButtonContainer>
              <StyledText>History</StyledText>
            </div>
            <DescriptionBody color={mashupBackground}>
              <CurveHolder>
                <Curve fill={mashupBackground} />
              </CurveHolder>
              <HistoryContainer>
                {gameData?.map((item) => (
                  <div
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                      height: 65,
                      borderRadius: 14,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      //   marginTop:15,
                      marginBottom: 15,
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: background,
                        width: "15%",
                        height: 65,
                        borderBottomLeftRadius: 15,
                        display: "flex",
                        borderTopLeftRadius: 15,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {item.won ? <TrophyIcon /> : <NoticeIcon />}
                    </div>

                    <div
                      style={{
                        width: "80%",
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      <StyledText style={{ fontSize: 12 }}>
                        {`You played ${item.title} ${item.category || ""} ${
                          item.won ? "and won" : ""
                        }`}
                      </StyledText>
                      <StyledText
                        style={{
                          fontSize: 10,
                          color: "#7F7F7F",
                          marginTop: -5,
                        }}
                      >{`Played on ${formatISODate(
                        item.createdAt
                      )}`}</StyledText>
                    </div>
                  </div>
                ))}
              </HistoryContainer>
            </DescriptionBody>
          </Children>
        </MainHolder>
      </Desktop>
   
    </>
  );
};

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
`;
const ViewAllHolder = styled.div`
  text-align: center;
  cursor: pointer;
`;
const HistoryContainer = styled.div`
  width: 80%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;
export default AllActivitiesScreen;
